/**
 * @desc 调拨批次汇总明细导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/batchDetailReport`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
